import { render } from "./shopping.vue?vue&type=template&id=0d20725e&scoped=true"
import script from "./shopping.vue?vue&type=script&lang=js"
export * from "./shopping.vue?vue&type=script&lang=js"

import "./shopping.vue?vue&type=style&index=0&id=0d20725e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d20725e"]])

export default __exports__